let setLoadingState = () => {};
// Fixed: show()/hide() used to be a plain boolean toggle, so two nested
// show/hide pairs (e.g. a delete handler that also triggers a reorder helper
// which independently shows/hides the same loader) could have the inner
// hide() turn the spinner off while the outer operation was still running —
// a premature "done" flash. Ref-counted so the loader only actually hides
// once every show() has a matching hide(). See docs/signage/ui-logic-bug-review.md.
let activeCount = 0;

const LoaderController = {
  show: () => {
    activeCount += 1;
    setLoadingState(true);
  },
  hide: () => {
    activeCount = Math.max(0, activeCount - 1);
    if (activeCount === 0) {
      setLoadingState(false);
    }
  },
  _register: (fn) => {
    setLoadingState = fn;
  }
};

export default LoaderController;
